import { Collection, getLogger } from "@mcleod/core";
import { DataSource } from "../databinding/DataSource";
import { Component } from "../base/Component";
import { ComponentTypes } from "../base/ComponentTypes";
import { PropType } from "../base/PropType";

const log = getLogger("components/serializer/ComponentSerializer");

export function serializeComponents(component: Component | Component[], dataSources: Collection<DataSource>) {
  if (Array.isArray(component)) {
    let result = "[\n";
    for (let i = 0; i < component.length; i++) {
      result += serializeComponents(component[i], dataSources);
      if (i < component.length - 1)
        result += ",";
      result += "\n";
    }
    result += "]"
    return result;
  }
  if (component == null) {
    log.info("Attempt to serialize null component %o", component);
    throw new Error("Could not serialize null component.");
  }
  let result = "{\n\"type\": \"" + ComponentTypes.getComponentTypeName(component) + "\",\n";
  const props = component.getPropertyDefinitions();
  result += serializeProps(component, props);
  if ((component as any)._serializeNonProps != null)
    result += (component as any)._serializeNonProps();
  result = result.substring(0, result.length - 2);
  if (dataSources != null && Object.keys(dataSources).length > 0) {
    result += ",\n\"dataSources\": [\n";
    for (const ds of Object.values(dataSources)) {
      result += "{\n";
      result += serializeProps(ds, (ds as DataSource).getPropertyDefinitions());
      result = result.substring(0, result.length - 2);
      result += "\n},\n";
    }
    result = result.substring(0, result.length - 2) + "\n";
    result += "]\n";
  }
  result += "\n}";
  return result;
}

export function serializeProps(component: Component | DataSource, props) {
  let result = "";
  for (const key in props) {
    let value = component[key];
    const prop = props[key];
    let defaultValue = component.getPropertyDefaultValue(prop);
    if (defaultValue === undefined && prop.type === PropType.bool)
      defaultValue = false;
    if (value instanceof DataSource)
      value = value.id;
    if (value != null && value !== defaultValue && (typeof value !== "string" || value.length > 0) && (Array.isArray(value) || typeof value !== "object"))
      result += "\"" + key + "\": " + JSON.stringify(value) + ",\n";
  }
  return result;
}
